// main.js
// The Vue build version to using the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import axios from 'axios'
import api from './apis'
import router from './router'
import './utils/element'
import BaiduMap from 'vue-baidu-map'
import { resolveInitialLang, createI18n } from './i18n'

let config = window.CONFIG_JSON

// 全局挂载
Vue.prototype.$http = axios
Vue.prototype.$api = api
Vue.prototype.$config = config
Vue.config.productionTip = false

import { formatLatLng4, formatTime, formatDate, calcPercent } from './utils/util'

// 全局注册格式化函数（原页面通过 data 暴露，这里保留兼容）
Vue.prototype.$formatLatLng4 = formatLatLng4
Vue.prototype.$formatTime = formatTime
Vue.prototype.$formatDate = formatDate
Vue.prototype.$calcPercent = calcPercent

// 全局错误处理
Vue.config.errorHandler = (err, vm, info) => {
  console.error('[Vue Error]', err, info)
  // 生产环境可上报 Sentry
}

// Vue.config.warnHandler = (msg, vm, trace) => {
//   if (process.env.NODE_ENV !== 'production') {
//     console.warn('[Vue Warn]', msg, trace)
//   }
// }

const BAIDU_MAP_AK =  'njYEQ5DXobgdkyQ8xJwAhYJh7nTmEQ3f'
// 全局只加载一次
let bmapLoadingPromise = null
function loadBMapGlobal(ak) {
  if (window.BMap && window.BMap.Map) return Promise.resolve()
  if (bmapLoadingPromise) return bmapLoadingPromise

  bmapLoadingPromise = new Promise((resolve, reject) => {
    const cb = 'initBMapGlobalCallback'
    window[cb] = () => {
      delete window[cb]
      resolve()
    }
    const s = document.createElement('script')
    s.src = `https://api.map.baidu.com/api?v=4.0&ak=${ak}&callback=${cb}`
    s.onerror = () => reject(new Error('BMap load failed'))
    document.head.appendChild(s)
  })
  return bmapLoadingPromise
}

Vue.prototype.$loadBMap = () => loadBMapGlobal(BAIDU_MAP_AK)



  /* eslint-disable no-new */
  ; (async () => {
    let lang = 'en'
    try {
      lang = await resolveInitialLang()
    } catch (e) {
      console.warn('[main] resolveInitialLang failed, fallback to en:', e && e.message)
    }

    const i18n = createI18n(lang)

    new Vue({
      el: '#app',
      router,
      i18n,
      components: { App },
      template: '<App/>'
    })
  })()



// WEBPACK FOOTER //
// ./src/main.js